import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { repeatWhen, switchMap, takeUntil, map } from "rxjs/operators";
import { Observable, Subject, timer, of, Subscription } from "rxjs";

@Directive({
  selector: "[disablesForTime]",
})
export class DisablesForTimeDirective<T> implements OnInit, OnDestroy {
  @Input() duration: number;

  private readonly observable$: Observable<number>;

  private subscription: Subscription;

  private readonly _stop = new Subject<void>();

  private readonly _start = new Subject<void>();

  private seconds = 0;

  constructor(private element: ElementRef) {
    this.observable$ = timer(1000, 1000).pipe(
      map(() => this.seconds--),
      takeUntil(this._stop),
      repeatWhen(() => this._start),
    );
  }

  ngOnInit() {
    this.seconds = this.duration;
  }
  /**
   *
   */
  @HostListener("click") onClick() {
    this.element.nativeElement.disabled = true;
    this.seconds = this.duration;
    this.subscription = this.observable$.subscribe((seconds) => {
      if (seconds !== 1) {
        return;
      }
      this.stop();
      this.element.nativeElement.disabled = false;
    });
  }

  /**
   *
   */
  start(): void {
    this.seconds = this.duration;
    this._start.next();
  }

  /**
   *
   */
  stop(): void {
    this._stop.next();
    this.subscription.unsubscribe();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
